import { render, staticRenderFns } from "./lotterydetails.vue?vue&type=template&id=275bc5cd"
import script from "./lotterydetails.vue?vue&type=script&lang=js"
export * from "./lotterydetails.vue?vue&type=script&lang=js"
import style0 from "./lotterydetails.vue?vue&type=style&index=0&id=275bc5cd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports